import { cn } from '../../../utils/clsx'

interface Tab {
    id: string
    label: string
    count?: number
}

interface CustomTabsProps {
    tabs: Tab[]
    activeTab: string
    onTabChange: (tabId: string) => void
    className?: string
    containerClassName?: string
}

export function CustomTabs({
    tabs,
    activeTab,
    onTabChange,
    className,
    containerClassName,
}: CustomTabsProps) {
    return (
        <div
            className={cn(
                'flex px-1 py-[3px] bg-slate-100 rounded-lg w-fit gap-2',
                containerClassName
            )}
        >
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => onTabChange(tab.id)}
                    className={cn(
                        'px-4 py-2 rounded-md transition-all font-medium whitespace-nowrap text-sm',
                        activeTab === tab.id
                            ? 'bg-slate-700 text-white shadow-sm'
                            : 'text-slate-600 bg-transparent hover:text-slate-700',
                        className
                    )}
                    type="button"
                >
                    {tab.label}
                    {tab.count !== undefined && ` (${tab.count})`}
                </button>
            ))}
        </div>
    )
}
